var _defs, _circle, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 511,
    height: 511,
    viewBox: "0 0 511 511",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#da0c81",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    result: "mask",
    in2: "SourceAlpha",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "mask",
    result: "dilated",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "dilated",
    result: "blurred",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blurred"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255.5,
    cy: 255.5,
    r: 255.5,
    fill: "url(#paint0_linear)",
    filter: "url(#glow)"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 511,
    y1: 0,
    x2: 0,
    y2: 511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2C2C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkCircle);
export default __webpack_public_path__ + "static/media/dark_circle.8c757b6dacf74dd006abc4415b9b7264.svg";
export { ForwardRef as ReactComponent };